import * as React from 'react';
import { Button, Alert } from 'tabler-react';
import store from '../../shared/store';

const NotFound = () => {
  const { affFailedMsg, affStatus } = store.user.object;
  // NON/CREATED/APPROVED/FAILED
  const message = {
    title: '加入 Malus 推荐返现计划',
    desc: '推荐用户认可的回国加速品牌，拿行业最高返现比例，20美元可提现。',
  };
  const style = {
    type: 'info',
    icon: 'info',
  };
  switch (affStatus) {
    case 'CREATED':
      message.title = '申请审核中';
      message.desc =
        '感谢加入 Malus推荐返现计划，您的申请正在审核中，我们将在1个工作日内反馈结果';
      style.type = 'warning';
      style.icon = 'info';
      break;
    case 'FAILED':
      message.title = '申请失败';
      message.desc = affFailedMsg;
      style.type = 'danger';
      style.icon = 'info';
      break;
    case 'APPROVED':
    case 'NON':
    default:
      break;
  }
  return (
    <Alert type={style.type} icon={style.icon}>
      <div className="alert-text">
        <h4> {message.title}</h4>
        <span>{message.desc}</span>
      </div>
      <Button
        pill
        className="btn-info"
        color="blue"
        RootComponent="a"
        href="/affiliate"
        target="noopener noreferrer">
        了解详情
      </Button>
    </Alert>
  );
};

export default NotFound;
